import { SLOTS } from 'types';
import { BetType } from './types';

export const EMPTY_BET: BetType = {
  [SLOTS.player]: 0,
  [SLOTS.banker]: 0,
  [SLOTS.tie]: 0,
  [SLOTS.playerPair]: 0,
  [SLOTS.bankerPair]: 0,
  [SLOTS.playerBonus]: 0,
  [SLOTS.bankerBonus]: 0,
  [SLOTS.anyPair]: 0,
  [SLOTS.perfectPair]: 0,
  [SLOTS.luckySeven]: 0,
  [SLOTS.luckySix]: 0,
};
